import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActionButtonComponent } from './action-button.component';

@NgModule({
  imports: [CommonModule],
  exports: [ActionButtonComponent],
  declarations: [ActionButtonComponent],
  providers: [],
})
export class ActionButtonModule {
}
